<template>
    <or-modal
        ref="new-custom-modal"
        :title="$t('common.modals.create_external.create_external.modal.title')"
        @close="resetForm"
    >
        <external-model-form
            ref="external-model-form"
            class="external-model-form-wrapper"
            :external-model="externalModel"
            :new-model="true"
            @submit="createExternalModel"
        >
            <template #actions>
                <div class="external-model-actions">
                    <or-button
                        color="primary"
                        buttonType="submit"
                        :loading="isLoading"
                    >
                      {{ $t('generic.create') }}
                    </or-button>
                </div>
            </template>
        </external-model-form>
    </or-modal>
</template>

<script>
import { mapActions } from 'vuex'
import uuid from 'uuid'
import KnowledgeBus from '@/KnowledgeBus'
import ExternalModelForm from './external-model-form'

const getEmptyExternalModel = () => ({
  name: '',
  engine: '',
  img: '',
  description: '',
  settings: {
    url: '',
    subscriptionKey: ''
  }
})

export default {
  components: {
    ExternalModelForm
  },

  created () {
    KnowledgeBus.$on('create-custom::open', this.openModal)
  },

  beforeDestroy () {
    KnowledgeBus.$off('create-custom::open', this.openModal)
  },

  data () {
    return {
      externalModel: getEmptyExternalModel(),

      isLoading: false
    }
  },

  methods: {
    ...mapActions('knowledgebase/customModels', ['createCustomModel']),

    openModal () {
      this.$refs['new-custom-modal'].open()
    },

    async createExternalModel (externalModel) {
      this.isLoading = true
      await this.createCustomModel({ ...externalModel, id: uuid.v4() })
      this.isLoading = false
      this.$refs['new-custom-modal'].close()
    },

    resetForm () {
      this.externalModel = getEmptyExternalModel()
      this.$refs['external-model-form'].$v.$reset()
    }
  }
}
</script>

<style lang="scss" scoped>
    .external-model-actions {
        display: flex;
        justify-content: flex-end;
    }
</style>
